export default {
  translation: {
    'Customer Information': '客户信息',
  },
};
